<template>
  <div class="demo">
    <div style="margin-bottom: 10px;">
      无图标按钮-普通按钮
      <SjButton style="margin-right: 20px" size="mini" theme="1"
        >mini-theme1</SjButton
      >
      <SjButton style="margin-right: 20px" size="small" theme="2"
        >small-theme2</SjButton
      >
      <SjButton style="margin-right: 20px" size="default" theme="3"
        >default-theme3</SjButton
      >
      <SjButton style="margin-right: 20px" size="middle" theme="4"
        >middle-theme4</SjButton
      >
      <SjButton style="margin-right: 20px" size="large" theme="4"
        >large-theme4</SjButton
      >
      <SjButton style="margin-right: 20px" disabled theme="2"
        >禁用-theme2</SjButton
      >
    </div>
    <div style="margin-bottom: 10px;">
      无图标按钮-loading状态
      <SjButton
        loading
        style="margin-right: 20px"
        size="mini"
        width="60"
        theme="1"
        >test</SjButton
      >
      <SjButton loading style="margin-right: 20px" size="small" theme="2"
        >test</SjButton
      >
      <SjButton loading style="margin-right: 20px" theme="3">test</SjButton>
      <SjButton loading style="margin-right: 20px" size="large" theme="4"
        >test</SjButton
      >
    </div>
    <div style="margin-bottom: 10px;">
      无图标按钮-loading状态 - 含有border
      <SjButton
        loading
        border
        style="margin-right: 20px"
        size="mini"
        width="60"
        theme="1"
        >test</SjButton
      >
      <SjButton loading border style="margin-right: 20px" size="small" theme="2"
        >test</SjButton
      >
      <SjButton loading border style="margin-right: 20px" theme="3"
        >test</SjButton
      >
      <SjButton loading border style="margin-right: 20px" size="large" theme="4"
        >test</SjButton
      >
    </div>
    <div style="margin-bottom: 10px;">
      无图标按钮-含border
      <SjButton style="margin-right: 20px" border size="mini" theme="1"
        >mini-theme1</SjButton
      >
      <SjButton style="margin-right: 20px" border size="small" theme="2"
        >small-theme2</SjButton
      >
      <SjButton style="margin-right: 20px" theme="3" border size="default"
        >default-theme3</SjButton
      >
      <SjButton style="margin-right: 20px" theme="4" border size="middle"
        >middle-theme4</SjButton
      >
      <SjButton style="margin-right: 20px" theme="4" border size="large"
        >large-theme4</SjButton
      >
      <SjButton
        style="margin-right: 20px"
        theme="1"
        border
        disabled
        size="large"
        >large-disabled-theme3</SjButton
      >
    </div>
    <div style="margin-bottom: 10px;">
      带图标按钮-无border
      <SjButton
        iconClass="comselect_info"
        style="margin:10px 20px"
        type="iconBtn"
        width="60"
        size="mini"
        >mini</SjButton
      >
      <SjButton
        iconClass="comselect_info"
        style="margin:10px 20px"
        type="iconBtn"
        size="small"
        >small</SjButton
      >
      <SjButton
        iconClass="comselect_info"
        style="margin:10px 20px"
        type="iconBtn"
        >default</SjButton
      >
      <SjButton
        iconClass="comselect_info"
        style="margin:10px 20px"
        size="middle"
        type="iconBtn"
        >middle</SjButton
      >
      <SjButton
        iconClass="comselect_info"
        style="margin:10px 20px"
        size="large"
        type="iconBtn"
        >large</SjButton
      >
      <SjButton
        iconClass="comselect_info"
        style="margin:10px 20px"
        disabled
        type="iconBtn"
        >禁用</SjButton
      >
    </div>

    <div style="margin-bottom: 10px;">
      带图标按钮-有border
      <SjButton
        iconClass="comselect_info"
        style="margin:10px 20px"
        type="iconBtn"
        size="mini"
        border
        theme="1"
        >mini-theme1</SjButton
      >
      <SjButton
        iconClass="comselect_info"
        style="margin:10px 20px"
        type="iconBtn"
        size="small"
        border
        theme="2"
        >small-theme2</SjButton
      >
      <SjButton
        iconClass="comselect_info"
        style="margin:10px 20px"
        type="iconBtn"
        border
        >default-theme1</SjButton
      >
      <SjButton
        iconClass="comselect_info"
        style="margin:10px 20px"
        type="iconBtn"
        size="middle"
        border
        >middle-theme1</SjButton
      >
      <SjButton
        iconClass="comselect_info"
        style="margin:10px 20px"
        type="iconBtn"
        size="large"
        border
        >large-theme1</SjButton
      >
      <SjButton
        iconClass="comselect_info"
        style="margin:10px 20px"
        type="iconBtn"
        border
        disabled
        >禁用</SjButton
      >
    </div>

    <div style="margin-bottom: 10px;">
      文字按钮
      <SjButton style="margin: 10px 20px" type="text" size="mini"
        >mini</SjButton
      >
      <SjButton style="margin: 10px 20px" type="text" size="small"
        >small</SjButton
      >
      <SjButton style="margin: 10px 20px" type="text">default</SjButton>
      <SjButton style="margin: 10px 20px" type="text" size="middle"
        >middle</SjButton
      >
      <SjButton style="margin: 10px 20px" type="text" size="large"
        >large</SjButton
      >
      <SjButton style="margin: 10px 20px" type="text" disabled>禁用</SjButton>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style scoped lang="less">
.demo {
  margin-top: 20px;
}
</style>
